/* eslint-disable import/prefer-default-export */
const prefix = 'cards'

export const SET_INITIAL_STATE = `${prefix}/SET_INITIAL_STATE`
export const SET_QUERY = `${prefix}/SET_QUERY`
